export const DEFAULT_CITY = 'madrid';
export const DEFAULT_ROOMS = '1';
export const MAX_ROOMS = 15;
export const MQ_DESKTOP_MIN_WIDTH = 1101;
export const MQ_TABLET_MAX_WIDTH = MQ_DESKTOP_MIN_WIDTH - 1;
export const MQ_TABLET_MIN_WIDTH = 701;
export const MQ_MOBILE_MAX_WIDTH = MQ_TABLET_MIN_WIDTH - 1;
export const MIN_LENGTH_AUTOCOMPLETER = 1;
export const HOMECARD_IMAGE_SIZES = {
  homecardHidpi: '640w',
  homecard: '320w'
};

export default {
  DEFAULT_CITY,
  MQ_DESKTOP_MIN_WIDTH,
  MQ_TABLET_MAX_WIDTH,
  MQ_TABLET_MIN_WIDTH,
  MQ_MOBILE_MAX_WIDTH,
  HOMECARD_IMAGE_SIZES,
  MIN_LENGTH_AUTOCOMPLETER
};
